import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bulk-petition-tags',
		path: '/admin/bulk_petition_tags',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-petition-bulkEditTags" */ './index'), {
			exportName: 'BulkTags',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
